import React, { Component } from 'react';

class Entity_0 extends Component {

  static defaultProps = {
    updateId : null,
    name : "UNDEFINED",
    registUpdateEntity : () => {
      
    },
    deleteEntity : () => {

    }
  }

  state = {

  }
  render() { 
    return (
      <div className="entity type-0">
        <p> Type 0 entity title </p>
      </div>
    );
  }
}
 
export default Entity_0;